"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    selected: false,
    fitContent: false,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map